<template>
  <div>
    <MenuBar />

    <div id="contactUsPage" class="mobileOnly">
      <FloatingMenu />

      <transition enter-active-class="animated fadeIn" appear>
        <div class="contactUsPageTitle">
          <span v-if="this.langChosen === 'gr'">문의하기</span>
          <span v-else>Contact Us</span>
        </div>
      </transition>

      <div class="heroImage" />

      <div class="contactContainer">
        <p>
          <span v-if="this.langChosen === 'gr'"
            >우리는 하지만 최고의 복권 소프트웨어 만 생산합니다 또한 Lotto Buster 소프트웨어에 대해 빠르고 고품질의 제품
            지원을 제공합니다. 질문이나 문제가있는 경우 아래 연락처 옵션을 사용하여 문의하십시오.</span
          >

          <span v-else
            >We are dedicated to not only producing the best lottery software available but also to giving fast, high
            quality product support for your Lotto Buster software. If you should have any questions or problems, do not
            hesitate to contact us using one of the below contact options.</span
          >
        </p>

        <p>
          <b>
            <span v-if="this.langChosen === 'gr'">연락처:</span>
            <span v-else>Contact Number:</span>
          </b>

          +82-115-5593-134
        </p>

        <p>
          <b>
            <span v-if="this.langChosen === 'gr'">이메일 주소:</span>
            <span v-else>Email Address:</span>
          </b>

          admin@busanlotteries.com
        </p>
      </div>
    </div>

    <div id="contactDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">문의하기</div>
          <div v-else>Contact Us</div>
        </transition>
      </div>

      <div class="flex">
        <LeftBannerAds />

        <div class="aboutDesktopField">
          <p>
            <span v-if="this.langChosen === 'gr'"
              >우리는 하지만 최고의 복권 소프트웨어 만 생산합니다 또한 빠르고 높은 서비스를 제공합니다. 로또 버스터
              소프트웨어에 대한 양질의 제품 지원, 질문이나 문제가 있으면 수행하십시오 아래 연락처 옵션 중 하나를
              사용하여 언제든지 문의하십시오.</span
            >

            <span v-else
              >We are dedicated to not only producing the best lottery software available but also to giving fast, high
              quality product support for your Lotto Buster software. If you should have any questions or problems, do
              not hesitate to contact us using one of the below contact options.</span
            >
          </p>

          <p>
            <b>
              <span v-if="this.langChosen === 'gr'">연락처:</span>
              <span v-else>Contact Number:</span>
            </b>

            +82-115-5593-134
          </p>
          <p>
            <b>
              <span v-if="this.langChosen === 'gr'">이메일 주소:</span>
              <span v-else>Email Address:</span>
            </b>

            admin@busanlotteries.com
          </p>
        </div>

        <RightBannerAds />
      </div>
    </div>

    <FifthSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FifthSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';
import LeftBannerAds from '../components/LeftBannerAds';
import RightBannerAds from '../components/RightBannerAds';

export default {
  components: {
    FloatingMenu,
    FifthSection,
    MenuBar,
    LeftBannerAds,
    RightBannerAds,
  },

  methods: {
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = '접촉 - 방콕 복권';
      } else {
        document.title = 'Contact - Busan Lotteries';
      }
    },
  },

  mounted() {
    this.setDocTitle();
  },
};
</script>

<style>
#contactUsPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  padding: 5vw;
  padding-top: 3.75vh;
  box-sizing: border-box;
}

.contactUsPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
  margin-bottom: 5.5vw;
}

#contactUsPage .heroImage {
  height: 35vh;
  background: url('../assets/contact-us.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  border-radius: 2vw 2vw 0 0;
  overflow: hidden;
}

.contactContainer {
  background-color: white;
  padding: 4vw;
  border-radius: 0 0 2vw 2vw;
  font-size: 0.98em;
}

.contactContainer p {
  margin: 0;
  margin-bottom: 3vw;
}

.contactContainer p:last-child {
  margin-bottom: 1vw;
}

#contactDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  #contactDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #contactDesktop .heroHeader {
    background-image: url('../assets/contact-us.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: center;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #contactDesktop .adsSpace1,
  #contactDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }
}
</style>
